import { ReactElement } from 'react'
import { Flexbox } from '../../components/flexbox/flexbox'
import { ScreenTitle } from '../../components/screen-title/screen-title'

const WithdrawalsScreen = (): ReactElement => {
  return (
    <Flexbox flex={1} isCol>
      <ScreenTitle title={'Withdrawals'} />
      No withdrawals yet
    </Flexbox>
  )
}

export default WithdrawalsScreen